let diagram = require('./diagramSymbol');

module.exports = {
  diagram: diagram
};